export default {
    HEADER: 'Terminal',
    PLACEHOLDER_NAME: 'Enter name',
    LABEL_NAME: 'Name',
    PLACEHOLDER_EMAIL: 'Enter email address',
    LABEL_EMAIL: 'Email',
    PLACEHOLDER_PASSWORD: 'Enter password',
    LABEL_NEW_PASSWORD: 'New password',
    PLACEHOLDER_NEW_PASSWORD: 'Enter new password',
    LABEL_PASSWORD: 'Password',
    PLACEHOLDER_DESCRIPTION: 'Enter description',
    LABEL_DESCRIPTION: 'Description',
    LABEL_STATUS: 'Status',
    LABEL_DEVICE_TYPE: 'Device type',
    DEVICE_TYPE_TABLET: 'TABLET',
    DEVICE_TYPE_PHONE: 'PHONE',
    PLACEHOLDER_DEVICE_ID: 'Enter device id',
    LABEL_DEVICE_ID: 'Device id',
    LABEL_ACCOUNT_ID: 'Account',
    SAVE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
};
